import type { ReduxState } from '@/redux'

export const proveDashboardOverviewData = (state: ReduxState) => state.proveDashboard.overview;
export const proveDashboardOverviewIsPending = (state: ReduxState) => state.proveDashboard.overviewIsPending;
export const proveDashboardOverviewIsError = (state: ReduxState) => state.proveDashboard.overviewIsError;
export const proveDashboardBreakdownData = (state: ReduxState) => state.proveDashboard.breakdown;
export const proveDashboardBreakdownIsPending = (state: ReduxState) => state.proveDashboard.breakdownIsPending;
export const proveDashboardBreakdownIsError = (state: ReduxState) => state.proveDashboard.breakdownIsError;
